// Modal.jsx (web)
import { motion } from 'framer-motion'
import { createPortal } from 'react-dom'

import Icon from '../Icon/Icon.js'
import { ModalBackdrop, ModalBody, ModalClose, ModalDialog, ModalTitle, ModalWrapper } from './Modal.styles.js'

const backdropVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
  exit: { opacity: 0 }
}

const dialogVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 30 }
}

const Modal = ({ children, title, onClose }) =>
  createPortal(
    <ModalWrapper as={motion.div} initial="hidden" animate="visible" exit="exit" variants={backdropVariants}>
      <ModalBackdrop onClick={onClose} />

      <ModalDialog as={motion.div} initial="hidden" animate="visible" exit="exit" variants={dialogVariants} transition={{ duration: 0.2 }}>
        <ModalClose onClick={onClose}>
          <Icon name="close" fill="#000000" />
        </ModalClose>
        {title && <ModalTitle>{title}</ModalTitle>}
        <ModalBody>{children}</ModalBody>
      </ModalDialog>
    </ModalWrapper>,
    document.body
  )

export default Modal
